var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{ref:"cascader",staticStyle:{"width":"100%"},attrs:{"value":_vm.categoryCode,"filterable":"","clearable":"","options":_vm.options,"props":{
    emitPath: false,
    checkStrictly: false,
    value: 'value',
    label: 'label',
  },"showAllLevels":false,"disabled":_vm.disabled,"size":_vm.size},on:{"change":_vm.change},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var node = ref.node;
  var data = ref.data;
return [_c('span',[_vm._v(_vm._s(data.label))]),(!node.isLeaf)?_c('span',[_vm._v(" ("+_vm._s(data.children.length)+") ")]):_vm._e()]}},{key:"empty",fn:function(){return [_c('div',[_vm._v(_vm._s(_vm.loading ? '加载中……' : '暂无数据'))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }